import React from 'react';

const PLAN_COLORS = { free: '#555', basic: '#2dd4bf', pro: '#6C63FF', agency: '#f59e0b' };

export default function PlanBadge({ plan }) {
  return (
    <span style={{ background: PLAN_COLORS[plan] || '#555', color: '#fff', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, textTransform: 'uppercase' }}>
      {plan}
    </span>
  );
}
